'use strict';

var GridRemoveSortButtonDirective = function GridRemoveSortButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-remove-sort-button.html'),
    controller: 'GridRemoveSortButtonController'
  };
};
GridRemoveSortButtonDirective.$inject = [];
module.exports = GridRemoveSortButtonDirective;